import React, { useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useMutation } from "react-query";
import ReCAPTCHA from "react-google-recaptcha";
import { useAppContext } from "../context/appContext";
import validator from "validator";
import { Mixpanel } from "../utils/Mixpanel";
import TokenService from "../utils/TokenService";
import MainMenu from "../components/MainMenu";
import LoginApi from "../service/LoginApi";
import { Avatar } from "primereact/avatar";
import { jwtDecode } from "jwt-decode";
import { throttle } from "lodash";

const loadScript = (src) =>
    new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve()
        const script = document.createElement('script')
        script.src = src
        script.onload = () => resolve()
        script.onerror = (err) => reject(err)
        document.body.appendChild(script)
    })

const Register = () => {
    const { displayAlert, setUserName } = useAppContext();
    const navigate = useNavigate();
    const [inputUserName, setInputUserName] = useState("");
    const [inputPassword, setInputPassword] = useState("");
    const mobileTopbarActive = false;
    const [changesMade, setChangesMade] = useState(false);
    const [pwdChangesMade, setPwdChangesMade] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [captchaVerified, setCaptchaVerified] = useState(false);
    // const [recaptcha, setRecaptcha] = useState('');
    // const recaptchaStatus = useScript(
    //     `https://www.google.com/recaptcha/api.js?render=explicit`,
    //     {
    //         removeOnUnmount: false,
    //     }
    // );
    const [captchaValue, setCaptchaValue] = useState(null);
    const [pwdLenghtMet, setPwdLenghtMet] = useState(false);
    const [pwdSpecialMet, setPwdSpecialMet] = useState(false);
    const [pwdLowercaseMet, setPwdLowercaseMet] = useState(false);
    const [pwdUppercaseMet, setPwdUppercaseMet] = useState(false);
    const [pwdNumberMet, setPwdNumberMet] = useState(false);
    const googleButton = useRef();
    const facebookEnabled = true;
    const [isFacebookProcessing, setIsFacebookProcessing] = useState(false);
    const [createCompanyIntent, setCreateCompanyIntent] = useState(false);

    const handleUserNameChange = (e) => {
        setInputUserName(e.target.value);
        setChangesMade(true);
    };

    const handlePasswordChange = (e) => {
        var _pwd = e.target.value;
        setInputPassword(_pwd);
        if (_pwd.length > 11) {
            setPwdLenghtMet(true);
        }
        else {
            setPwdLenghtMet(false);
        }
        var uppercaseRegex = /[A-Z]/;
        var hasUppercase = uppercaseRegex.test(_pwd);
        if (hasUppercase) {
            setPwdUppercaseMet(true);
        }
        else {
            setPwdUppercaseMet(false);
        }
        var lowercaseRegex = /[a-z]/;
        var hasLowercase = lowercaseRegex.test(_pwd);
        if (hasLowercase) {
            setPwdLowercaseMet(true);
        }
        else {
            setPwdLowercaseMet(false);
        }
        var specialRegex = /[!@#$%^&*()_+,.?;:{}|<>/\-]/;
        var hasSpecial = specialRegex.test(_pwd);
        if (hasSpecial) {
            setPwdSpecialMet(true);
        }
        else {
            setPwdSpecialMet(false);
        }
        var numberRegex = /[0-9]/;
        var hasNumber = numberRegex.test(_pwd);
        if (hasNumber) {
            setPwdNumberMet(true);
        }
        else {
            setPwdNumberMet(false);
        }
        setChangesMade(true);
        setPwdChangesMade(true);
    };

    const registerApi = useMutation((values) => {
        let wcsrft = TokenService.getCsrfToken('wcsrft');
        const requestBody = {
            recaptcha: captchaValue,
            payload: values,
            wcsrft: wcsrft
        };
        try {
            const data = LoginApi.post("auth/register", requestBody, {
                withCredentials: true,
            }).then((response) => response.data);
            return data;
        } catch (error) {
            fetchAuthToken();
            throw error;
        }
    });

    const onSubmit = (e) => {
        e.preventDefault();
        submitAction();
    }

    const submitAction = throttle(() => {
        if (!inputUserName || !inputPassword) {
            displayAlert("error", "Error", "Please enter a valid email address and password");
            Mixpanel.track("UI Registration - failed all validation");
            return;
        }
        if (!validator.isEmail(inputUserName)) {
            displayAlert("error", "Error", "Please enter a valid email address");
            Mixpanel.track("UI Registration - failed email validation");
            return;
        }
        if (!validator.isStrongPassword(inputPassword, {
            minLength: 12,
            minLowercase: 1,
            minUppercase: 1,
            minNumbers: 1,
            minSymbols: 1,
        })) {
            if (inputPassword.length < 12) {
                displayAlert("error", "Error", "Password must be at least 12 characters");
                Mixpanel.track("UI Registration - failed password validation length");
            }
            else {
                var uppercaseRegex = /[A-Z]/;
                var hasUppercase = uppercaseRegex.test(inputPassword);
                if (!hasUppercase) {
                    displayAlert("error", "Error", "Password must contain one uppercase letter");
                    Mixpanel.track("UI Registration - failed password validation uppercase letter");
                }
                else {
                    var lowercaseRegex = /[a-z]/;
                    var hasLowercase = lowercaseRegex.test(inputPassword);
                    if (!hasLowercase) {
                        displayAlert("error", "Error", "Password must contain one lowercase letter");
                        Mixpanel.track("UI Registration - failed password validation lowercase letter");
                    }
                    else {
                        var specialRegex = /[!@#$%^&*()_+,.?;:{}|<>/\-]/;
                        var hasSpecial = specialRegex.test(inputPassword);
                        if (!hasSpecial) {
                            displayAlert("error", "Error", "Password must contain one special character");
                            Mixpanel.track("UI Registration - failed password validation special character");
                        }
                        else {
                            var numberRegex = /[0-9]/;
                            var hasNumber = numberRegex.test(inputPassword);
                            if (!hasNumber) {
                                displayAlert("error", "Error", "Password must contain one number");
                                Mixpanel.track("UI Registration - failed password validation number");
                            }
                            else {
                                // TODO we shouldn't get here assuming our validation is correct.
                                displayAlert(
                                    "error",
                                    "Error",
                                    "Password must be 12 characters with at least 1 uppercase, 1 lowercase, 1 digit, and 1 special character"
                                );
                                Mixpanel.track("UI Registration - failed password validation");
                            }
                        }
                    }
                }
            }
            return;
        }
        var values = {};
        values.email = inputUserName;
        values.password = inputPassword;
        setIsProcessing(true);
        registerApi.mutate(values, {
            onError: (error, variables, context) => {
                setIsProcessing(false);
                if (error && error.request.status === 409) {
                    displayAlert(
                        "error",
                        "Unexpected Error",
                        "This email address already exists. Please login instead."
                    );
                    Mixpanel.track("UI Registration - failed as email already exists");
                } else {
                    displayAlert("error", "Unexpected Error", "Please try again later");
                    Mixpanel.track("UI Registration - failed API error");
                }
            },
            onSuccess: (data) => {
                TokenService.setAccessToken(data.userAccessToken);
                TokenService.setRefreshToken(data.userRefreshToken);
                displayAlert("success", "Success", "Registration successful. Please verify your email address.");
                Mixpanel.register({
                    email: inputUserName
                });
                Mixpanel.identify(inputUserName);
                Mixpanel.people.set({ "$email": inputUserName });
                setUserName(inputUserName);
                Mixpanel.track("UI Registration - successful");
                navigate("/verify-email");
            },
        });
    }, 500, { trailing: false });

    const layoutContainerClassName = classNames(
        "layout-wrapper ",
        "pages-body",
        "login-page",
        "flex",
        "flex-column",
        "layout-menu-cyan layout-topbar-cyan",
        {
            "layout-topbar-mobile-active": mobileTopbarActive,
            "p-input-outlined": "outlined",
        }
    );

    const footer = (
        <>
            <div className="mt-1">
                <div>
                    {pwdChangesMade && pwdLenghtMet && (<i className="pi pi-check mr-2 text-green-400"></i>)}
                    {pwdChangesMade && !pwdLenghtMet && (<i className="pi pi-times mr-2 text-pink-400"></i>)}
                    {!pwdChangesMade && (<i className="pi pi-minus mr-2"></i>)}
                    Minimum 12 characters
                </div>
                <div>
                    {pwdChangesMade && pwdLowercaseMet && (<i className="pi pi-check mr-2 text-green-400"></i>)}
                    {pwdChangesMade && !pwdLowercaseMet && (<i className="pi pi-times mr-2 text-pink-400"></i>)}
                    {!pwdChangesMade && (<i className="pi pi-minus mr-2"></i>)}
                    At least one lowercase
                </div>
                <div>
                    {pwdChangesMade && pwdUppercaseMet && (<i className="pi pi-check mr-2 text-green-400"></i>)}
                    {pwdChangesMade && !pwdUppercaseMet && (<i className="pi pi-times mr-2 text-pink-400"></i>)}
                    {!pwdChangesMade && (<i className="pi pi-minus mr-2"></i>)}
                    At least one uppercase
                </div>
                <div>
                    {pwdChangesMade && pwdNumberMet && (<i className="pi pi-check mr-2 text-green-400"></i>)}
                    {pwdChangesMade && !pwdNumberMet && (<i className="pi pi-times mr-2 text-pink-400"></i>)}
                    {!pwdChangesMade && (<i className="pi pi-minus mr-2"></i>)}
                    At least one number
                </div>
                <div>
                    {pwdChangesMade && pwdSpecialMet && (<i className="pi pi-check mr-2 text-green-400"></i>)}
                    {pwdChangesMade && !pwdSpecialMet && (<i className="pi pi-times mr-2 text-pink-400"></i>)}
                    {!pwdChangesMade && (<i className="pi pi-minus mr-2"></i>)}
                    At least one special character
                </div>
            </div>
        </>
    );

    const fetchAuthToken = () => {
        return LoginApi.get("auth/tkn")
            .then((response) => response.data)
            .catch((error) => {
                console.error('Failed to fetch token:', error);
                var mixpanelMessage = "Error getting login token: " + error;
                Mixpanel.track("UI ID - Javascript error", {
                    'Javascript Error': mixpanelMessage
                });
            });
    };

    useEffect(() => {
        fetchAuthToken();

        if (TokenService.isAuthenticated()) {
            if (TokenService.isLoggedIn()) {
                if (!TokenService.isUserProfileComplete()) {
                    navigate("/complete-profile");
                } else {
                    navigate("/account/select-provider");
                }
            }
            else {
                navigate("/verify-email");
            }
        }
        else {
            const searchParams = new URLSearchParams(window.location.search);
            if (searchParams.has("promote-my-company")) {
                TokenService.setRedirectOnLogin(process.env.REACT_APP_NETWORK_SITE + "/company/create-profile");
                setCreateCompanyIntent(true);
            }
            const googleSrc = 'https://accounts.google.com/gsi/client';

            loadScript(googleSrc)
                .then(() => {
                    window.google.accounts.id.initialize({
                        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
                        callback: handleCredentialResponse,
                    })
                    window.google.accounts.id.renderButton(
                        googleButton.current, //this is a ref hook to the div in the official example
                        {
                            type: 'standard',
                            shape: 'rectangular',
                            text: 'signin_with',
                            theme: 'outline',
                            size: 'large',
                            logo_alignment: 'left',
                            width: '300px'
                        })

                })
                .catch(console.error)

            const facebookSrc = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v21.0&appId=' + process.env.REACT_APP_FACEBOOK_APP_ID + '&autoLogAppEvents=1';
            loadScript(facebookSrc);
            // if (facebookEnabled) {
            //     const facebookSrc = 'https://connect.facebook.net/en_US/sdk.js';
            //     loadScript(facebookSrc)
            //         .then(() => {
            //             window.FB.init({
            //                 appId: process.env.REACT_APP_FACEBOOK_APP_ID,
            //                 cookie: true,
            //                 xfbml: true,
            //                 version: 'v21.0'
            //             });
            //         })
            //         .catch(console.error)
            // }
            return () => {
                const googleScriptTag = document.querySelector(`script[src="${googleSrc}"]`)
                if (googleScriptTag) document.body.removeChild(googleScriptTag)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // const showResponse = (response) => {
    //     setCaptchaVerified(true);
    //     setRecaptcha(response.response);
    // };

    const loginWithFacebookApi = useMutation((body) => {
        try {
            const data = LoginApi.post("auth/login-facebook", body).then((response) => response.data);
            return data;
        } catch (error) {
            throw error;
        }
    });

    function handleCredentialResponse(response) {
        const responsePayload = jwtDecode(response.credential);
        let email = responsePayload.email;
        let wcsrft = TokenService.getCsrfToken('wcsrft');
        let body = {}
        body.email = email;
        body.credential = response.credential;
        body.wcsrft = wcsrft;
        // Log into Wallist
        LoginApi.post("auth/login-google", body).then((response) => {
            setUserName(email);
            TokenService.setAccessToken(response.data.userAccessToken);
            TokenService.setRefreshToken(response.data.userRefreshToken);
            Mixpanel.register({
                email: email
            });
            Mixpanel.identify(email);
            Mixpanel.people.set({ "$email": email });
            Mixpanel.track("UI Google Registration - successful");
            if (!TokenService.isUserProfileComplete()) {
                navigate("/complete-profile");
            } else {
                TokenService.redirectUser(response.data.providerCount);
            }
        }).catch((error) => {
            displayAlert("error", "Unexpected Error", "Unexpected error. Please try again later");
            Mixpanel.track("UI Google Registration - failed API error");
            console.log(error);
            fetchAuthToken();
        });
    }

    const onCaptchaChange = (value) => {
        setCaptchaValue(value);
        setCaptchaVerified(true);
    };

    const handleFacebookLogin = () => {
        try {
            window.FB.login(function (response) {
                if (response.status === 'connected') {
                    setIsFacebookProcessing(true);
                    window.FB.api(
                        '/' + response.authResponse.userID + '/?fields=id,name,email',
                        'GET',
                        {},
                        function (apiResponse) {
                            let email = apiResponse.email;
                            let name = apiResponse.name;
                            let wcsrft = TokenService.getCsrfToken('wcsrft');

                            // Extract first name and last name from full name
                            let firstName = "";
                            let lastName = "";
                            if (name) {
                                const nameParts = name.trim().split(/\s+/);
                                if (nameParts.length > 1) {
                                    firstName = nameParts.slice(0, -1).join(" ");
                                    lastName = nameParts[nameParts.length - 1];
                                } else {
                                    firstName = name;
                                    lastName = "";
                                }
                            }

                            // Store in sessionStorage for CompleteProfile to use
                            if (firstName) {
                                sessionStorage.setItem('facebookFirstName', firstName);
                            }
                            if (lastName) {
                                sessionStorage.setItem('facebookLastName', lastName);
                            }

                            let body = {
                                email,
                                signedRequest: response.authResponse.signedRequest,
                                facebookUserId: response.authResponse.userID,
                                wcsrft: wcsrft
                            };

                            // Log into Wallist
                            loginWithFacebookApi.mutate(body, {
                                onError: (error) => {
                                    displayAlert("error", "Unexpected Error", "Please try again later");
                                    Mixpanel.track("UI Facebook Registration - failed API error");
                                    console.log(error);
                                    fetchAuthToken();
                                    setIsFacebookProcessing(false);
                                },
                                onSuccess: (data) => {
                                    TokenService.setAccessToken(data.userAccessToken);
                                    TokenService.setRefreshToken(data.userRefreshToken);
                                    Mixpanel.register({ email });
                                    Mixpanel.identify(email);
                                    Mixpanel.people.set({ "$email": email });
                                    Mixpanel.track("UI Facebook Registration - successful");
                                    setUserName(email);
                                    if (!TokenService.isUserProfileComplete()) {
                                        navigate("/complete-profile");
                                    } else {
                                        TokenService.redirectUser(data.providerCount);
                                    }
                                },
                            });
                        }
                    );
                }
            }, { scope: 'public_profile,email' });
        }
        catch (error) {
            displayAlert("error", "Unexpected Error", "Please try again later");
            Mixpanel.track("UI Facebook Registration - failed API error");
            console.log(error);
        }
    };

    return (
        <div className={layoutContainerClassName}>
            <MainMenu />

            <div className="align-self-center mt-auto mb-auto">
                <div className="pages-panel card flex flex-column p-4">
                    {createCompanyIntent && (
                        <div style={{ maxWidth: "385px" }}>
                            <h5 className="pages-detail mb-3 font-bold text-left">To create your company profile on Wallist, please sign up using Google{facebookEnabled && " or Facebook"}</h5>
                        </div>
                    )}
                    {!createCompanyIntent && (
                        <h5 className="pages-detail mb-3 font-bold">Sign up using Google{facebookEnabled && " or Facebook"}</h5>
                    )}
                    <div className="flex mt-1 justify-content-center" style={{ height: "50px" }}>
                        <div ref={googleButton}></div>
                    </div>
                    {facebookEnabled && (
                        <div className="flex mt-1 justify-content-center">
                            <Button
                                className="p-button-outlined"
                                style={{ width: "300px", height: "40px", backgroundColor: "#1877f2", color: "white" }}
                                onClick={handleFacebookLogin}
                                loading={isFacebookProcessing}
                                label="Continue with Facebook"
                                icon="pi pi-facebook"
                            />
                        </div>
                    )}
                    <div className="grid mt-1 mb-1 mt-3">
                        <div className="col-5">
                            <hr />
                        </div>
                        <div className="col-2 font-bold">
                            <Avatar label="or" shape="circle" />
                        </div>
                        <div className="col-5">
                            <hr />
                        </div>
                    </div>
                    <h5 className="pages-detail mb-3 mt-2 font-bold">Register with email and password</h5>
                    <form className="form" onSubmit={onSubmit}>
                        <div className="input-panel flex flex-column px-3 mt-2">
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <InputText
                                        type="text"
                                        id="username"
                                        name="username"
                                        value={inputUserName}
                                        onChange={handleUserNameChange}
                                    />
                                    <label htmlFor="username">Email Address</label>
                                </span>
                            </div>

                            <div className="flex justify-content-center p-inputgroup mt-3 sm:mt-5">
                                <span className="p-float-label">
                                    <Password
                                        inputId="password"
                                        value={inputPassword}
                                        onChange={handlePasswordChange}
                                        feedback={true}
                                        toggleMask
                                        className={classNames({ "p-invalid": pwdChangesMade && (!pwdLenghtMet || !pwdLowercaseMet || !pwdUppercaseMet || !pwdNumberMet || !pwdSpecialMet) })}
                                        footer={footer}
                                        strongRegex="^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+,.?;:{}|<>/\-])(?=.{12,}).*$"
                                        mediumRegex="^(?=.*[A-Z])(?=.*[a-z])(?=.{8,}).*$"
                                    />
                                    <label htmlFor="password">Password</label>
                                </span>
                            </div>
                        </div>
                        <div className="grid mt-5">
                            <div className="col"></div>
                            <div className="col flex align-content-center justify-content-center" style={{ height: "115px" }} >
                                <ReCAPTCHA
                                    sitekey="6LfrqnwlAAAAAJgZU__T_KL3YD35wN-vYl4gwYHp"
                                    onChange={onCaptchaChange}
                                />
                                {/* {recaptchaStatus && (<Captcha className="mt-4" siteKey="6LfrqnwlAAAAAJgZU__T_KL3YD35wN-vYl4gwYHp" onResponse={showResponse}></Captcha>)} */}
                            </div>
                            <div className="col"></div>
                        </div>
                        <div className="grid text-center mt-1">
                            <div className="col">
                                <Button
                                    className="login-button mb-1 sm:mb-3 px-8"
                                    label="Register"
                                    icon="pi pi-check"
                                    type="submit"
                                    disabled={!changesMade || isProcessing || !captchaVerified || !pwdLenghtMet || !pwdLowercaseMet || !pwdUppercaseMet || !pwdNumberMet || !pwdSpecialMet}
                                    loading={isProcessing}
                                ></Button>
                            </div>
                        </div>
                    </form>
                    <span>
                        Already registered? <a href={process.env.REACT_APP_ID_SITE + "/login"}>Login here</a>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Register;
